import { Select } from "@mantine/core";
import type { Locale } from "@project/common";
import { supportedLocalesOptions } from "@project/common";
import { useTRPC } from "../../trpc";
import { useUser } from "../../hooks/user";
import { useLocale, useSetLocale } from "../../hooks/locale";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function LanguagePicker() {
  const locale = useLocale();
  const user = useUser();
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const setLocale = useSetLocale();

  const { mutateAsync: changeLocale } = useMutation(trpc.changeLocale.mutationOptions());

  const handleChange = (value: string | null = "en") => {
    setLocale(value as Locale);
    if (user) {
      void changeLocale(value as Locale)
        .then((updated) => {
          queryClient.setQueryData(trpc.getCurrentUser.queryKey(), updated);
        });
    }
  };

  return (
    <Select
      data={supportedLocalesOptions.map(({ value, localLabel }) => ({ value, label: localLabel }))}
      value={locale}
      allowDeselect={false}
      searchable={true}
      onChange={handleChange}
    />
  );
}
